import { FLYOUT_CLICKED, ON_VALID_VIN_DATA, onVehicleIdentificationErrorUpdated } from '../actions';
import { VehicleSelectionHierarchyLabel, VehicleSelectionMethod, VehicleIdentificationErrorCode } from '../enums';
import { flyoutClickedAction } from './flyoutClicked';
import { vinDecodeAction } from './vinDecode';
import { put } from 'redux-saga/effects';
function manualSelectClicked(vehicleInfo, vehicleSelectionMethod) {
    const updatedVehicleInfo = Object.assign(Object.assign({}, vehicleInfo), { VehicleSelectionMethod: vehicleSelectionMethod });
    if (vehicleSelectionMethod !== VehicleSelectionMethod.VinDecode) {
        return flyoutClickedAction({
            type: FLYOUT_CLICKED,
            payload: {
                vehicleInfo: updatedVehicleInfo,
                vehicleSelectionHierarchyLabel: VehicleSelectionHierarchyLabel.Types,
                vehicleSelectionMethod
            }
        });
    }
    if (updatedVehicleInfo.Vin) {
        return vinDecodeAction({
            type: ON_VALID_VIN_DATA,
            payload: {
                vehicleInfo: updatedVehicleInfo,
                vin: updatedVehicleInfo.Vin
            }
        });
    }
    return null;
}
export default function* manualSelectClickedAction(action) {
    const { vehicleInfo, vehicleSelectionMethod } = action.payload;
    try {
        yield put(onVehicleIdentificationErrorUpdated({ errorCode: VehicleIdentificationErrorCode.Default }));
        yield manualSelectClicked(vehicleInfo, vehicleSelectionMethod);
    }
    catch (e) { }
}
//# sourceMappingURL=manualSelectClicked.js.map